if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.fromInput = this.querySelector('[data-input="from"]');
      this.toInput = this.querySelector('[data-input="to"]');
      this.fromSlider = this.querySelector('[data-slider="from"]');
      this.toSlider = this.querySelector('[data-slider="to"]');

      this.filterForm = this.closest('filter-form-collection');

      this.filtersDesktop = document.querySelector('filters-desktop');

      this.addEventListener('click', () => {
        this.removeDisabledFormInputs();
      });

      this.initEventListeners();
      this.fillSlider();
      this.setToggleAccessible();

      this.staticSetPrice();
    }


    initEventListeners() {
      this.fromSlider.addEventListener('change', () => {
        this.removeDisabledFormInputs();
        this.controlFromSlider();
        this.filterFormRender();
      });
      this.toSlider.addEventListener('change', () => {
        this.removeDisabledFormInputs();
        this.fromInput.removeAttribute('disabled');
        this.toInput.removeAttribute('disabled');
        this.controlToSlider();
        this.filterFormRender();
      });
      this.fromInput.addEventListener('change', () => {
        this.controlFromInput();
        this.fillSlider();
        this.filterFormRender();
      });
      this.toInput.addEventListener('change', () => {
        this.controlToInput();
        this.fillSlider();
        this.filterFormRender();
      });
    }

    fillSlider() {
      const rangeDistance = this.toSlider.max - this.toSlider.min;
      const fromPosition = this.fromSlider.value - this.toSlider.min;
      const toPosition = this.toSlider.value - this.toSlider.min;
      this.toSlider.style.background = `linear-gradient(
          to right,
          #C9C8D3 0%,
          #C9C8D3 ${(fromPosition / rangeDistance) * 100}%,
          #000000 ${((fromPosition / rangeDistance)) * 100}%,
          #000000 ${(toPosition / rangeDistance) * 100}%,
          #C9C8D3 ${(toPosition / rangeDistance) * 100}%,
          #C9C8D3 100%)`;
    }

    setToggleAccessible() {
      if (Number(this.toInput.value) <= 0) {
        this.toSlider.style.zIndex = 2;
      } else {
        this.toSlider.style.zIndex = 0;
      }
    }

    controlFromInput() {
      let [from, to] = this.getParsed(this.fromInput, this.toInput);
      if (isNaN(from)) {
        from = 0;
      } else if (from > to) {
        from = to;
        this.fromInput.value = from;
      }
      this.fillSlider();
      this.fromSlider.value = from;
    }

    controlToInput() {
      let [from, to] = this.getParsed(this.fromInput, this.toInput);
      if (isNaN(to)) {
        return;
      }
      this.fillSlider();
      this.setToggleAccessible();
      if (from <= to) {
        this.toSlider.value = to;
        this.toInput.value = to;
      } else {
        return
      }
    }

    controlFromSlider() {
      const [from, to] = this.getParsed(this.fromSlider, this.toSlider);
      this.fillSlider();
      if (from > to) {
        this.fromSlider.value = to;
        this.fromInput.value = to;
      } else {
        this.fromInput.value = from;
      }
    }

    controlToSlider() {
      const [from, to] = this.getParsed(this.fromSlider, this.toSlider);
      this.fillSlider();
      this.setToggleAccessible();
      if (from <= to) {
        this.toSlider.value = to;
        this.toInput.value = to;
      } else {
        this.toInput.value = from;
        this.toSlider.value = from;
      }
    }

    getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }

    filterFormRender() {
      this.filterForm.render();
    }

    setDefaultRangePrice() {
      this.fromInput.value = this.dataset.min;
      this.toInput.value = this.dataset.max;
      this.fromSlider.value = this.dataset.min;
      this.toSlider.value = this.dataset.max;
      this.setDisabledFormInputs();
      this.fillSlider();
    }

    setDisabledFormInputs() {
      this.fromInput.setAttribute('disabled', '');
      this.toInput.setAttribute('disabled', '');
    }

    removeDisabledFormInputs() {
      this.fromInput.removeAttribute('disabled');
      this.toInput.removeAttribute('disabled');
      this.filtersDesktop.selectedFiltersSize();
    }

    staticSetPrice() {
      this.fromSlider.addEventListener('input', (e) => {
        this.fromInput.value = this.fromSlider.value;
        this.fillSlider();

      })

      this.toSlider.addEventListener('input', (e) => {
        this.toInput.value = this.toSlider.value;
        this.fillSlider();
      })
    }
  }

  customElements.define('price-range', PriceRange);
}
